import React, { useState } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { selectTagDefinitions, selectCampaign } from '../../../store/site'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import DefinitionForm from './DefinitionForm'
import Heading from 'constructicon/heading'
import Section from 'constructicon/section'

const AdminLeaderboardDefinitions = ({
  campaign = {},
  children,
  classNames,
  styles,
  tagDefinitions = []
}) => {
  if (!tagDefinitions.length) return <p>No tag definitions found</p>
  if (!campaign.uid) return <p>No campaign config found</p>

  const [activeDefinition, setActiveDefinition] = useState(tagDefinitions[0])

  return (
    <Section spacing={{ t: 1, x: 1, b: 0 }}>
      <Heading size={1.5}>
        Configure Leaderboard definitions
      </Heading>
      <nav className={classNames.nav}>
        {tagDefinitions.map(definition => (
          <button
            key={definition.id}
            onClick={() => setActiveDefinition(definition)}
            className={[classNames.tab, activeDefinition.id === definition.id ? classNames.active : undefined].join(' ')}
          >
            {definition.label}
          </button>
        ))}
      </nav>
      {activeDefinition && (
        <DefinitionForm
          {...activeDefinition}
          key={activeDefinition.id}
          campaign={campaign.uid}
        />
      )}
    </Section>
  )
}

const mapState = (state) => ({
  campaign: selectCampaign(state),
  tagDefinitions: selectTagDefinitions(state)
})

export default compose(
  connect(mapState),
  withStyles(styles)
)(AdminLeaderboardDefinitions)
